// 配置各模块使用 v3 接口还是 v4 接口

export default {
  meeting: 'v3',
  user: 'v3',
  customMenu: 'v3',
  insertFile: 'v3',
  virtualClient: 'v3',
  interactive: 'v3',
  doc: 'v3',
  group: 'v3',
  imChat: 'v3',
  imKeyWords: 'v3',
  imPrivateChat: 'v3',
  imSignaling: 'v3',
  imNotice: 'v3',
  imChatAuth: 'v3',
  activity: 'v3', //活动开关
  player: 'v3',
  brand: 'v3',
  qa: 'v3',
  rebroadcast: 'v3',
  // gifts: 'v3',
  entryform: 'v3',
  gray: 'v3',
  gifts: 'v3',
  signUpForm: 'v3'
};

//中台api接口清单
export const meetingApiList = {
  initSendLive: {
    v3: "/v3/webinars/live/init",
  },
  initSendLiveYun: {
    v3: "/v3/webinars/live/director-seat-init",
  },
  getStreamStatus: {
    v3: "/v3/webinars/director/get-stream-status",
  },
  selectSeat: {
    v3: "/v3/webinars/director/select-seat",
  },
}

export const roomApiList = {
  startLive: {
    v3: "/v3/webinars/live/start",
  },
  endLive: {
    v3: "/v3/webinars/live/end",
  },
  getInavToolStatus: {
    v3: "/v3/interacts/room/get-inav-tool-status",
  },
  setDeviceStatus: {
    v3: "/v3/interacts/room/set-device-status",
  },
  setDevice: {
    v3: "/v3/interacts/room/set-device",
  },
  webinarInitBefore: {
    v3: "/v3/webinars/webinar/init-before-union",
  },
  getActivityBasicInfo: {
    v3: "/v3/webinars/webinar/info",
  },
  updateJoinInfo: {
    v3: "/v3/webinars/watch/update-join-info"
  },
  switchBroadcast: {
    v3: '/v3/interacts/room/switch-broadcast'
  }
}

export const roomSubjectApiList = {
  subjectInitBefore: {
    v3: "/v3/webinars/subject/init-before",
  },
  getSubjectInfo: {
    v3: "/v3/webinars/subject-watch/subject-watch-info",
  },
  getWebinarList: {
    v3: "/v3/webinars/subject/get-webinar-list",
  },
  subjectWatchAuth: {
    v3: "/v3/webinars/subject-watch/subject-auth"
  },
  initSubjectInfo: {
    v3: "/v3/webinars/subject-watch/subject-init"
  },
  getAnswerInfo: {
    v3: "/v3/webinars/registration-form/get-answer-info"
  },
  getRegWebinarList: {
    v3: "/v3/webinars/subject-watch/get-reg-webinar-list"
  }
}

// 视频轮询 api
export const videoRoundApiList = {
  videoRoundInfo: {
    v3: "/v3/interacts/video-round/info",
  },
  videoRoundStart: {
    v3: '/v3/interacts/video-round/start'
  },
  videoRoundEnd: {
    v3: '/v3/interacts/video-round/end'
  },
  videoRoundGetUsers: {
    v3: '/v3/interacts/video-round/get-round-users'
  }
}
